import { downloadFile } from '@chocolate-soup-inc/cs-api-consumer-utils';
import * as XLSX from 'xlsx';

export type TReportSheet = (number | string | null | undefined)[][];
export type TReportFormat = 'csv' | 'xlsx';

export const downloadReport = async (data: TReportSheet, filename: string, format: TReportFormat, signal?: AbortSignal) => {
  if (signal?.aborted) return;
  if (format === 'csv') {
    const worksheet = XLSX.utils.aoa_to_sheet(data);
    downloadFile({ data: [XLSX.utils.sheet_to_csv(worksheet)], filename: `${filename}.csv`, filetype: 'text/csv;charset=utf-8' });
    return;
  }

  const { Workbook } = await import('exceljs');
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet('Report');
  data.forEach((row) => worksheet.addRow(row));
  const contents = await workbook.xlsx.writeBuffer();
  if (signal?.aborted) return;
  downloadFile({ data: [new Uint8Array(contents)], filename: `${filename}.xlsx`, filetype: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
};
